import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import { Chart } from 'chart.js'
import globalMixin from '../globalMixin'
import EtatStockOutput from './models/EtatStockOutput'

export default mixins(routeMixin, globalMixin).extend({
    data() {
        return {
            companyName: '',
            etatStock: null as null | EtatStockOutput,
            codeFamilleSelectionne: '',
            chart: null as null | Chart<'doughnut', number[], string>
        }
    },
    methods: {
        formatDate(date: Date) {
            return new Date(date).toLocaleDateString('fr-FR')
        },
        loadEtatStocks() {
            this.etatStock = null
            this.codeFamilleSelectionne = ''

            if (!this.companyName) return null
            this.$loader.go()

            return this.$http
                .api(`etatStock?name=` + this.companyName)
                .get()
                .then(x => {
                    this.etatStock = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    },
    computed: {}
})
